module.exports = __webpack_public_path__ + "img/2.93550118.jpg";